import axios, { AxiosResponse } from 'axios'

import { formatDate } from '@/helpers/date'
import { DateFormat } from '@/types'

export const getTracksForMe = (includes: string[], startDate: Date, endDate: Date): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/me/tracks`,
    {
        params: {
            include: includes.join(','),
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
        },
    },
)

export const getTrack = (includes: string[], trackUuid: string): Promise<AxiosResponse> => axios.get(
    `${process.env.REACT_APP_API_URL}/tracks/${trackUuid}`,
    {
        params: {
            include: includes.join(','),
        },
    },
)
